import { render } from "./TabPreferencesThird.vue?vue&type=template&id=059bf008&scoped=true"
import script from "./TabPreferencesThird.vue?vue&type=script&lang=js"
export * from "./TabPreferencesThird.vue?vue&type=script&lang=js"

import "./TabPreferencesThird.vue?vue&type=style&index=0&id=059bf008&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059bf008"]])

export default __exports__